import { IconSettingsSliderHor } from 'central-icons/IconSettingsSliderHor';
import classNames from 'classnames';
import type { CSSProperties } from 'react';

import { IconButton, RevelioTooltip } from '@revelio/ui';

import styles from './customise-columns-button.module.css';

interface CustomiseColumnsButtonProps {
  onClick: () => void;
  right?: number;
  variant?: 'default' | 'compact';
  height?: string;
  hideTopRightRadius?: boolean;
}

export const CustomiseColumnsButton = ({
  onClick,
  right,
  variant = 'default',
  height,
  hideTopRightRadius = false,
}: CustomiseColumnsButtonProps) => {
  const isCompact = variant === 'compact';
  const positionerVars = {
    ...(right === undefined ? {} : { '--ccb-right': `${right}px` }),
    ...(height === undefined ? {} : { '--ccb-height': height }),
  } as CSSProperties;

  return (
    <div
      className={styles.positioner}
      style={positionerVars}
      data-testid="manage-table-columns-positioner"
    >
      <RevelioTooltip label="Manage Columns" placement="top">
        <IconButton
          className={classNames(
            styles.button,
            isCompact ? styles.compactVariant : styles.defaultVariant,
            hideTopRightRadius && styles.squareCorners
          )}
          aria-label="Manage Columns"
          icon={
            <IconSettingsSliderHor
              color="var(--ccb-icon, #555e68)"
              size={isCompact ? '16px' : '18px'}
            />
          }
          size="lg"
          shape="squared"
          variant="ghost"
          onClick={onClick}
          data-testid="manage-table-columns-button"
        />
      </RevelioTooltip>
    </div>
  );
};
